import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5231 2 22 6.47686 22 12C22 17.5231 17.5231 22 12 22C9.65057 22 7.42254 21.1853 5.64474 19.7216C4.65887 18.908 3.83556 17.9145 3.2224 16.7951C2.42455 15.3374 2 13.6982 2 12C2 6.47686 6.47686 2 12 2ZM12 3C7.02914 3 3 7.02914 3 12C3 13.5293 3.38183 15.0035 4.09952 16.3148C4.65145 17.3224 5.39304 18.2173 6.2808 18.95C7.88076 20.2672 9.88468 21 12 21C16.9709 21 21 16.9709 21 12C21 7.02914 16.9709 3 12 3ZM11.48 7C11.745 7 11.9599 7.21621 11.9599 7.48291V12.4085L14.7669 14.1029C14.9942 14.2401 15.0679 14.5367 14.9315 14.7655C14.7952 14.9942 14.5004 15.0683 14.2731 14.9311L11.233 13.0961C11.0885 13.0088 11 12.8516 11 12.6819V7.48291C11 7.21621 11.2149 7 11.48 7Z"
      />
    </svg>
  );
}